import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Button, Table, Alert, Row, Col, Modal } from "react-bootstrap";
import api from "../axiosConfig";

const ClienteForm = () => {
  const [clientes, setClientes] = useState([]);
  const [form, setForm] = useState({
    tipo_cliente_id: "",
    nombres: "",
    apellidos: "",
    nombre_contacto: "",
    tipo_identificacion_id:"",
    doc_identificacion: "",
    direccion: "",
    ciudad: "",
    estado: "",
    codigo_postal: "",
    telefono: "",
    correo: "",
    fecha_nacimiento: "",
    nacionalidad_id: "",
    estado_civil_id: "",
    
  });
  const [editandoId, setEditandoId] = useState(null);
  const [error, setError] = useState("");

   // Listas dinámicas para selects
  const [tiposCliente, setTiposCliente] = useState([]);
  const [tiposIdentificacion, setTiposIdentificacion] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [estadosCiviles, setEstadosCiviles] = useState([]);


  //  NUEVO
  const [busqueda, setBusqueda] = useState("");
  const [pagina, setPagina] = useState(1);
  const [totalClientes, setTotalClientes] = useState(0);
  const porPagina = 20;

  //alertas
  const [mensaje, setMensaje] = useState(null);

  // Hijos
const [mostrarHijos, setMostrarHijos] = useState(false);
const [hijos, setHijos] = useState([]);
const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

  const mostrarMensaje = (tipo, texto) => {
    setMensaje({ tipo, texto });
    setTimeout(() => setMensaje(null), 4000); // se oculta en 4s
  };

  useEffect(() => {
    obtenerClientes();
  }, [pagina, busqueda]);

  // Cargar opciones para selects
  useEffect(() => {
    const cargarOpciones = async () => {
      try {
        const [respCliente, respIdent, respNac, respCivil] = await Promise.all([
          api.get("/catalogos/tipos-cliente"),
          api.get("/catalogos/tipos-identificacion"),
          api.get("/catalogos/nacionalidades"),
          api.get("/catalogos/estados-civiles"),
        ]);
        setTiposCliente(respCliente.data);
        setTiposIdentificacion(respIdent.data);
        setNacionalidades(respNac.data);
        setEstadosCiviles(respCivil.data);
      } catch (err) {
        console.error("Error cargando selects", err);
      }
    };
    cargarOpciones();
  }, []);

  const obtenerClientes = async () => {
    try {
      const skip = (pagina - 1) * porPagina;
      const response = await api.get("/clientes/", {
        params: {
          buscar: busqueda,
          skip,
          limit: porPagina,
        },
      });
      setClientes(response.data.resultados); // ← revisar si backend envía `resultados`
      setTotalClientes(response.data.total); // ← revisar si backend envía `total`
    } catch (err) {
      setError("Error al obtener clientes");
    }
  };
  //HIJOS
  const abrirModalHijos = async (cliente) => {
  setClienteSeleccionado(cliente);
  try {
    const resp = await api.get(`/clientes/${cliente.id}`);
    setHijos(resp.data.hijos || []);
    setMostrarHijos(true);
  } catch (err) {
    console.error("Error al cargar hijos:", err);
    setHijos([]);
    setMostrarHijos(true);
  }
};

const calcularEdad = (fecha) => {
  if (!fecha) return "";
  const hoy = new Date();
  const nacimiento = new Date(fecha);
  let edad = hoy.getFullYear() - nacimiento.getFullYear();
  const mes = hoy.getMonth() - nacimiento.getMonth();
  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
    edad--;
  }
  return edad;
};

const actualizarHijo = (index, campo, valor) => {
  setHijos(prev =>
    prev.map((h, i) => {
      if (i === index) {
        const actualizado = { ...h, [campo]: valor };
        if (campo === "fecha_nacimiento") {
          actualizado.edad = calcularEdad(valor);
        }
        return actualizado;
      }
      return h;
    })
  );
};

const agregarHijo = () => {
  setHijos(prev => [...prev, { nombre: "", fecha_nacimiento: "", edad: "", relacion: "" ,numero_social: ""}]);
};

const eliminarHijo = (index) => {
  setHijos(prev => prev.filter((_, i) => i !== index));
};

const guardarHijos = async () => {
  try {
    await api.put(`/clientes/${clienteSeleccionado.id}`, {
      ...clienteSeleccionado,
      hijos
    });
    mostrarMensaje("success", "Hijos actualizados correctamente");
    setMostrarHijos(false);
    obtenerClientes(); // refrescar lista
  } catch (err) {
    console.error("Error al guardar hijos:", err);
    mostrarMensaje("danger", "Error al guardar hijos");
  }
};

  const handleBuscar = (e) => {
    setBusqueda(e.target.value);
    setPagina(1);
  };

  const totalPaginas = Math.ceil(totalClientes / porPagina);

  const handlePagina = (nueva) => {
    if (nueva >= 1 && nueva <= totalPaginas) {
      setPagina(nueva);
    }
  };

  const handleChange = (e) => {
  const { name, value } = e.target;
  // Estos campos deben ser numéricos
  const camposNumericos = ["tipo_cliente_id", "tipo_identificacion_id", "nacionalidad_id", "estado_civil_id"];
  setForm((prev) => ({
    ...prev,
    [name]: camposNumericos.includes(name) && value !== "" ? Number(value) : value,
  }));
};

  const limpiarFormulario = () => {
    setForm({
      tipo_cliente: "",
      nombres: "",
      apellidos: "",
      nombre_contacto: "",
      tipo_identificacion:"",
      doc_identificacion: "",
      direccion: "",
      ciudad: "",
      estado: "",
      codigo_postal: "",
      telefono: "",
      correo: "",
      fecha_nacimiento: "",
      nacionalidad: "",
      estado_civil: "",
     
    });
    setEditandoId(null);
    setError("");
  };

  
   const handleEditar = (cliente) => {
  setForm({
    tipo_cliente_id: Number(cliente.tipo_cliente_id) || "",
    nombres: cliente.nombres || "",
    apellidos: cliente.apellidos || "",
    nombre_contacto: cliente.nombre_contacto || "",
    tipo_identificacion_id: cliente.tipo_identificacion_id !== null ? Number(cliente.tipo_identificacion_id) : "",
    doc_identificacion: cliente.doc_identificacion || "",
    direccion: cliente.direccion || "",
    ciudad: cliente.ciudad || "",
    estado: cliente.estado || "",
    codigo_postal: cliente.codigo_postal || "",
    telefono: cliente.telefono || "",
    correo: cliente.correo || "",
    fecha_nacimiento: cliente.fecha_nacimiento || "",
    nacionalidad_id: cliente.nacionalidad_id !== null ? Number(cliente.nacionalidad_id) : "",
    estado_civil_id: cliente.estado_civil_id !== null ? Number(cliente.estado_civil_id) : "",
    
  });
  setEditandoId(cliente.id);
  setError("");
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Prepara los datos para enviar, cuidando tipos y nulls
    const datosEnviar = { ...form };
// Campos numéricos opcionales vacíos → null
  ["tipo_cliente_id", "tipo_identificacion_id", "nacionalidad_id", "estado_civil_id"].forEach(campo => {
    if (datosEnviar[campo] === "" || datosEnviar[campo] === undefined) datosEnviar[campo] = null;
  });

  // Fecha de nacimiento vacía → null
  if (!datosEnviar.fecha_nacimiento) datosEnviar.fecha_nacimiento = null;

  // Número de hijos vacío → null si es natural
  if (datosEnviar.tipo_cliente_id === 2 && !datosEnviar.numero_hijos) datosEnviar.numero_hijos = null;

  // Campos que no aplican para empresas
  if (datosEnviar.tipo_cliente_id === 1) {
    datosEnviar.apellidos = null;
    datosEnviar.fecha_nacimiento = null;
    datosEnviar.nacionalidad_id = null;
    datosEnviar.estado_civil_id = null;
   
  } 
  
  
   // Campos de texto opcionales → null si están vacíos
  if (!datosEnviar.correo) datosEnviar.correo = null;
  if (!datosEnviar.direccion) datosEnviar.direccion = null;
  if (!datosEnviar.ciudad) datosEnviar.ciudad = null;
  if (!datosEnviar.estado) datosEnviar.estado = null;
  if (!datosEnviar.codigo_postal) datosEnviar.codigo_postal = null;
  if (!datosEnviar.telefono) datosEnviar.telefono = null;


  

    // Validar campos obligatorios
    if (!datosEnviar.tipo_cliente_id || !datosEnviar.nombres || !datosEnviar.doc_identificacion) {
      setError("Completa todos los campos obligatorios para este cliente.");
      return;
    }

    /// Validar que el documento no se repita (solo al crear, o si es otro cliente)
const existeDocumento = clientes.some(c => 
  c.doc_identificacion === datosEnviar.doc_identificacion && c.id !== editandoId
);

if (existeDocumento) {
  setError("El documento de identidad ya está registrado para otro cliente.");
  return;
}



      // Validar formato de email si no es null
  if (datosEnviar.correo && !/^\S+@\S+\.\S+$/.test(datosEnviar.correo)) {
    setError("El correo no es válido. Debe tener un formato como ejemplo@dominio.com");
    return;
  }

    try {
      if (editandoId) {
        await api.put(`/clientes/${editandoId}`, datosEnviar);
        mostrarMensaje("warning", "Cliente actualizado correctamente");
      } else {
        await api.post("/clientes/", datosEnviar);
        mostrarMensaje("success", "Cliente registrado correctamente.\nRecuerda para generar el ticket debe tener los campos completos de dirección, ciudad, estado, código postal y teléfono.");
      }


      obtenerClientes();
      limpiarFormulario();
    } catch (err) {
  console.error("Error al guardar cliente:", err.response?.data || err);
  if (err.response?.data?.detail) {
    err.response.data.detail.forEach(e => {
      console.warn(`Campo con error: ${e.loc.join(" -> ")}, mensaje: ${e.msg}`);
    });
  }
  setError("Error al guardar cliente.");
}
  };

 

  const handleEliminar = async (id) => {
    try {
      await api.delete(`/clientes/${id}`);
      mostrarMensaje("danger", "Cliente eliminado correctamente");
      obtenerClientes();
      if (editandoId === id) limpiarFormulario();
    } catch (err) {
      setError("Error al eliminar cliente");
    }
  };

  const esClienteNatural = form.tipo_cliente_id === 2;
  const esClienteEmpresa = form.tipo_cliente_id === 1;

  return (
    <div className="card p-4">
  <h3 className="text-primary">{editandoId ? "Editar Cliente" : "Registrar Cliente"}</h3>
  {error && <Alert variant="danger">{error}</Alert>}
  {mensaje && (
  <div className={`alert alert-${mensaje.tipo} mt-3`} role="alert">
    {mensaje.texto}
  </div>
)}

  <Form onSubmit={handleSubmit}>
    <Row>
      {/* Tipo de Cliente */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Tipo de Cliente</Form.Label>
          <Form.Select 
            size="sm"
            name="tipo_cliente_id" 
            value={form.tipo_cliente_id || ""} 
            onChange={handleChange}
          >
            <option value="">Seleccione...</option>
            {tiposCliente.map((t) => (
              <option key={t.id} value={t.id}>{t.nombre}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>

      {/* Nombres / Razón Social */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>{esClienteNatural ? "Nombres" : "Razón Social"}</Form.Label>
          <Form.Control name="nombres" value={form.nombres} onChange={handleChange} required />
        </Form.Group>
      </Col>

      {/* Apellidos solo para natural */}
      {esClienteNatural && (
        <Col xs={12} md={4}>
          <Form.Group className="mb-2">
            <Form.Label>Apellidos</Form.Label>
            <Form.Control name="apellidos" value={form.apellidos} onChange={handleChange} required />
          </Form.Group>
        </Col>
      )}

       {esClienteEmpresa && (
  <Col xs={12} md={4}>
    <Form.Group className="mb-2">
      <Form.Label>Nombre de Contacto</Form.Label>
      <Form.Control
        name="nombre_contacto"
        value={form.nombre_contacto}
        onChange={handleChange}
        
      />
    </Form.Group>
  </Col>
)}

      {/* Tipo Identificación */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Tipo Identificación</Form.Label>
          <Form.Select
            size="sm"
            name="tipo_identificacion_id"
            value={form.tipo_identificacion_id}
            onChange={handleChange}
          >
            <option value="">Seleccione...</option>
            {tiposIdentificacion.map((ti) => (
              <option key={ti.id} value={ti.id}>{ti.nombre}</option>
            ))}
          </Form.Select>
        </Form.Group>
      </Col>

      {/* Documento de Identificación */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Documento de Identificación</Form.Label>
          <Form.Control name="doc_identificacion" value={form.doc_identificacion} onChange={handleChange} 
          required  title="El documento de identidad es único y no se puede repetir." />
        </Form.Group>
      </Col>

      {/* Fecha de Nacimiento solo para natural */}
      {esClienteNatural && (
        <Col xs={12} md={4}>
          <Form.Group className="mb-2">
            <Form.Label>Fecha de Nacimiento</Form.Label>
            <Form.Control type="date" name="fecha_nacimiento" value={form.fecha_nacimiento} onChange={handleChange} />
          </Form.Group>
        </Col>
      )}

      {/* Nacionalidad */}
      {esClienteNatural && (
        <Col xs={12} md={4}>
          <Form.Group className="mb-2">
            <Form.Label>Nacionalidad</Form.Label>
            <Form.Select
              size="sm"
              name="nacionalidad_id"
              value={form.nacionalidad_id}
              onChange={handleChange}
            >
              <option value="">Seleccione...</option>
              {nacionalidades.map((n) => (
                <option key={n.id} value={n.id}>{n.nombre}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}

      {/* Estado Civil */}
      {esClienteNatural && (
        <Col xs={12} md={4}>
          <Form.Group className="mb-2">
            <Form.Label>Estado Civil</Form.Label>
            <Form.Select
              size="sm"
              name="estado_civil_id"
              value={form.estado_civil_id}
              onChange={handleChange}
            >
              <option value="">Seleccione...</option>
              {estadosCiviles.map((e) => (
                <option key={e.id} value={e.id}>{e.nombre}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}

    

      {/* Dirección */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Dirección</Form.Label>
          <Form.Control name="direccion" value={form.direccion} onChange={handleChange} />
        </Form.Group>
      </Col>

      {/* Ciudad */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Ciudad</Form.Label>
          <Form.Control name="ciudad" value={form.ciudad} onChange={handleChange} />
        </Form.Group>
      </Col>

      {/* Estado */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Estado</Form.Label>
          <Form.Control name="estado" value={form.estado} onChange={handleChange} />
        </Form.Group>
      </Col>

      {/* Código Postal */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Código Postal</Form.Label>
          <Form.Control name="codigo_postal" value={form.codigo_postal} onChange={handleChange} />
        </Form.Group>
      </Col>

      {/* Teléfono */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Teléfono</Form.Label>
          <Form.Control name="telefono" value={form.telefono} onChange={handleChange} />
        </Form.Group>
      </Col>

      {/* Correo */}
      <Col xs={12} md={4}>
        <Form.Group className="mb-2">
          <Form.Label>Correo</Form.Label>
          <Form.Control type="email" name="correo" value={form.correo} onChange={handleChange} 
          pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
          title="Debe tener el formato ejemplo@dominio.com"/>
        </Form.Group>
      </Col>
    </Row>

    

    <Button type="submit" variant="primary" className="me-2">
      {editandoId ? "Actualizar" : "Registrar"}
    </Button>
    
      <Button variant="secondary" onClick={limpiarFormulario}>
        Cancelar
      </Button>
    
  </Form>
  <Col xs={12} md={3}>
  <h5 className="mt-4">Lista de Clientes</h5>
  <Form.Group className="mb-3">
    <Form.Control
      type="text"
      placeholder="Buscar por nombre o apellido"
      value={busqueda}
      onChange={handleBuscar}
    />
  </Form.Group>
  </Col>
  <div className="table-responsive">
    
  <Table striped bordered hover responsive>
    <thead>
      <tr>
        <th>ID</th>
        <th>Tipo</th>
        <th>Nombre</th>
        <th>Documento</th>
        <th>Dirección</th>
        <th>Acciones</th>
      </tr>
    </thead>
    <tbody>
      {clientes.map((cli) => (
        <tr key={cli.id}>
          <td>{cli.id}</td>
          <td>{tiposCliente.find((t) => t.id === cli.tipo_cliente_id)?.nombre || cli.tipo_cliente_id}</td>
          <td>{cli.tipo_cliente === 2 ? cli.nombres : `${cli.nombres} ${cli.apellidos || ""}`}</td>
          <td>{cli.doc_identificacion}</td>
          <td>{cli.direccion ? `${cli.direccion}, ${cli.ciudad || ""}, ${cli.estado || ""}` : "-"}</td>
          
          <td>
            <button onClick={() => handleEditar(cli)} className="btn btn-sm "  
            style={{ backgroundColor: "#4e73df", borderColor: "#1cc88a", color: "#fff" }}>✏ Editar</button>{" "}
            {/*<button onClick={() => handleEliminar(cli.id)} className="btn btn-sm btn-danger">🗑 Eliminar</button>*/}
              {cli.tipo_cliente_id === 2 && (<button 
    onClick={() => abrirModalHijos(cli)} 
    className="btn btn-sm btn-success">
    👨‍👩‍👧 Hijos
  </button>
              )}
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
  </div>

  {/* Paginación */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <Button variant="secondary" disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>← Anterior</Button>
          <span>Página {pagina} de {totalPaginas}</span>
          <Button variant="secondary" disabled={pagina === totalPaginas} onClick={() => setPagina(p => p + 1)}>Siguiente →</Button>
  </div>
  <Modal show={mostrarHijos} onHide={() => setMostrarHijos(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Hijos de {clienteSeleccionado?.nombres}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Número de Seguro Social</th>
          <th>Fecha de Nacimiento</th>
          <th>Edad</th>
          <th>Relación</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {hijos.map((h, i) => (
          <tr key={i}>
            <td>
              <Form.Control
                value={h.nombre || ""}
                onChange={(e) => actualizarHijo(i, "nombre", e.target.value)}
              />
            </td>
            <td>
              <Form.Control
                value={h.numero_social || ""}
                onChange={(e) => actualizarHijo(i, "numero_social", e.target.value)}
              />
            </td>
            <td>
              <Form.Control
                type="date"
                value={h.fecha_nacimiento || ""}
                onChange={(e) => actualizarHijo(i, "fecha_nacimiento", e.target.value)}
              />
            </td>
            <td>
              <Form.Control
                type="number"
                value={h.edad || ""}
                onChange={(e) => actualizarHijo(i, "edad", e.target.value)}
              />
            </td>
            <td>
              <Form.Control
                value={h.relacion || ""}
                onChange={(e) => actualizarHijo(i, "relacion", e.target.value)}
              />
            </td>
            
            <td>
              <Button 
                variant="danger" 
                size="sm" 
                onClick={() => eliminarHijo(i)}>
                🗑
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
    <Button onClick={agregarHijo}>➕ Agregar hijo</Button>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setMostrarHijos(false)}>Cerrar</Button>
    <Button variant="primary" onClick={guardarHijos}>Guardar cambios</Button>
  </Modal.Footer>
</Modal>
</div>
  );
};

export default ClienteForm;





